'use strict';

module.exports.addSlashToEnd = function (path) {
  if (!path) throw Error('path could not be empty!');
  var length = path.length - 1;
  var isSlash = path[length] === '/';
  if (isSlash) return path;
  return "".concat(path, "/");
};
/** Функция получает короткие размеры
 * конвертируя байт в килобайты, мегабойты,
 * гигайбайты и терабайты
 * @pSize - размер в байтах
 */


module.exports.size = function (size) {
  var isNumber = typeof size === 'number';
  var l1KB = 1024;
  var l1MB = l1KB * l1KB;
  var l1GB = l1MB * l1KB;
  var l1TB = l1GB * l1KB;
  var l1PB = l1TB * l1KB;
  if (!isNumber) return size;
  if (size < l1KB) return size + 'b';
  if (size < l1MB) return (size / l1KB).toFixed(2) + 'kb';
  if (size < l1GB) return (size / l1MB).toFixed(2) + 'mb';
  if (size < l1TB) return (size / l1GB).toFixed(2) + 'gb';
  if (size < l1PB) return (size / l1TB).toFixed(2) + 'tb';
  return (size / l1PB).toFixed(2) + 'pb';
};

module.exports.permissions = require('./mode');